import { api } from "./useApi";
import { TagDestaque } from "../types/Produto";

export const tagsApi = () => ({
  getTags: async (): Promise<TagDestaque[]> => {
    let response = await api.post("empresa/tagsLista");
    return response.data;
  },
  criarTag: async (nome_tag: string): Promise<TagDestaque> => {
    let response = await api.post("empresa/tags/criar", { nome_tag });
    return response.data;
  },
  atualizarTag: async (id: number, dados: Partial<TagDestaque>): Promise<TagDestaque> => {
    let response = await api.post("empresa/tags/atualizar", { id, ...dados });
    return response.data;
  },
  removerTag: async (id: number): Promise<void> => {
    let response = await api.post("empresa/tags/remover", { id });
    return response.data;
  }
});
